module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/jackpot_title@1x.png?1.0.17";